import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const useAdminAuth = () => {
  const [user, setUser] = useState(undefined);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const invalidate = useCallback(() => setUser(null), []);

  useEffect(() => {
    const controller = new AbortController();
    setError(null);
    axios.get(`${API}/auth/me`, { withCredentials: true, signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) setUser(data); })
      .catch((err) => {
        if (controller.signal.aborted) return;
        if (err.response?.status !== 401) setError("Impossible de vérifier l'accès administrateur. Réessaie.");
        setUser(null);
      });
    return () => controller.abort();
  }, [attempt]);

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      setUser(null);
    } catch {
      toast.error("Déconnexion impossible, réessaie");
    }
  };
  const retry = () => { setUser(undefined); setAttempt((value) => value + 1); };
  return { user, error, retry, logout, invalidate };
};